import {Box} from "@mui/material";
import {InsightsLoading} from "./insightsLoading";
import {StatCard, StatCardData} from "./StatCard";

const CARD_MIN_WIDTH = 200;
const GAP = 1.5;

interface Props {
    items: StatCardData[];
    loading?: InsightsLoading;
    /** One state for every card's target, for screens whose targets load separately from their figures. */
    targetLoading?: InsightsLoading;
}

/** Responsive grid for stat cards, fitting as many columns as width allows. */
export function StatGrid({items, loading, targetLoading}: Props) {
    if (items.length === 0) {
        return null;
    }

    return (
        <Box
            sx={{
                display: "grid",
                gap: GAP,
                gridTemplateColumns: `repeat(auto-fill, minmax(min(${CARD_MIN_WIDTH}px, 100%), 1fr))`,
                minWidth: 0,
            }}
        >
            {items.map(item => (
                <StatCard key={item.id} data={item} loading={loading} targetLoading={targetLoading}/>
            ))}
        </Box>
    );
}
